module.exports = __webpack_public_path__ + "static/img/cloud-computing.593c6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud-computing.png
// module id = 7+hz
// module chunks = 1